import { classNameKey } from './class-name.js'

export type ExtractedHoneyColour = 'light' | 'amber' | 'dark'

const seedColours = new Map<string, ExtractedHoneyColour>([
  ['h-extracted-honey-light', 'light'],
  ['h-extracted-honey-amber', 'amber'],
  ['h-extracted-honey-dark', 'dark'],
])
const namedColours = new Map<string, ExtractedHoneyColour>([
  ['light extracted honey', 'light'],
  ['amber extracted honey', 'amber'],
  ['dark extracted honey', 'dark'],
])

/**
 * Recognize frozen class metadata without depending on an installation's catalog IDs. Names
 * compare as class titles do elsewhere: without the schedule designator, case or spacing.
 */
export function classifyExtractedHoneyColour({
  modelClassKey,
  name,
  code,
}: {
  modelClassKey: string | null
  name: string
  code?: string | null
}): ExtractedHoneyColour | null {
  const seeded = modelClassKey === null ? undefined : seedColours.get(modelClassKey)
  return seeded ?? namedColours.get(classNameKey(name, code ?? '')) ?? null
}
